import { useCallback, useState } from 'react'
import { VisuallyHidden } from '@overdose/components'
import classNames from 'classnames'
import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import { Link } from '~/components'
import { AccountQuickViewDrawer } from '~/components/AccountQuickViewDrawer'
import {
  navigationCardData1,
  navigationCardData2,
  navigationCardData3,
} from '~/components/AccountQuickViewDrawer/AccountQuickViewDrawer.mock'

import { Image } from '~/components/Image'
import { SectionContainer } from '~/components/SectionContainer'
import { useCustomer, usePage } from '~/hooks'
import jaycarLogo from '~/public/images/jaycar-logo.svg'
import rtmLogo from '~/public/images/rtm-logo.svg'
import { HeaderProps } from '../Header/Header.types'
import MenuIcons from '../Header/MenuIcons'
import styles from './SimpleHeader.module.css'

const MegaMenu = dynamic(
  async () => {
    const mod = await import('~/components/MegaMenu')
    return mod.MegaMenu
  },
  { ssr: false }
)

const headerLinks = {
  loyaltyLink: {
    href: '/account/rewards',
    title: 'View all',
  },
  ordersLink: {
    href: '/account/orders',
    title: 'View all',
  },
  accountsInfoLink: {
    href: '/account/dashboard',
    title: 'View all',
  },
}

const SimpleHeader = ({ width = 'full', megaMenu }: HeaderProps) => {
  const page = usePage()
  const { customer } = useCustomer()
  const router = useRouter()

  const [openAccountQuickViewer, setOpenAccountQuickViewer] = useState(false)
  const handleAccountViewer = useCallback(() => {
    if (customer) {
      setOpenAccountQuickViewer(true)
    } else {
      router.push({ hash: 'login' })
    }
  }, [customer, router])

  const [openMegaMenu, setOpenMegaMenu] = useState(false)
  return (
    <SectionContainer
      width={width}
      tag='header'
      innerClassName='relative px-4 py-6 lg:py-5 lg:px-20 h-20 bg-[var(--header-color-bg)]'
      wrapperClassName='sticky top-0 z-10'>
      <div className='flex items-center justify-between gap-x-10'>
        <Link title='View Home Page' href='/' className='inline-block'>
          <Image
            src={jaycarLogo}
            alt='Jaycar Logo'
            width={148}
            height={40}
            className={classNames('hidden', styles.jaycarLogo)}
          />
          <Image
            src={rtmLogo}
            alt='RTM Logo'
            width={148}
            height={40}
            className={classNames('hidden', styles.rtmLogo)}
          />
          <VisuallyHidden>View Home Page</VisuallyHidden>
        </Link>
        <MenuIcons
          setOpenMegaMenu={setOpenMegaMenu}
          handleAccountViewer={handleAccountViewer}
        />
      </div>
      <AccountQuickViewDrawer
        open={openAccountQuickViewer}
        onClose={() => {
          setOpenAccountQuickViewer(false)
        }}
        navData={[
          navigationCardData1,
          navigationCardData2,
          navigationCardData3,
        ]}
        headerLinks={headerLinks}
      />
      <MegaMenu
        isOpen={openMegaMenu}
        categories={page.primaryNavigation}
        {...megaMenu}
        onClose={() => {
          return setOpenMegaMenu(false)
        }}
      />
    </SectionContainer>
  )
}

export { SimpleHeader }
